import {FILE_TYPE, ID, IMPREST_ID} from "../../../constants/filters";
import {FILE_TYPES} from "../../../constants/file";

export const GetAccountTitlesFilter = id => {
  return filtersNormalize({ id });
};

const filtersNormalize = filters => {
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [IMPREST_ID]: filters[ID]
  };
};
